import { motion } from "framer-motion";

export function StatBlock({ value, label, delta, dark = false, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5 }}
      data-testid={testId}
      className="min-w-0"
    >
      <div className={`font-extrabold leading-tight ${String(value).length > 9 ? "text-2xl md:text-3xl lg:text-4xl" : String(value).length > 6 ? "text-3xl md:text-4xl" : "text-3xl md:text-5xl"} ${dark ? "text-white" : "text-navy"}`}>
        {value}
      </div>
      <div className={`mt-2 text-xs font-medium uppercase tracking-widest md:text-sm ${dark ? "text-white/60" : "text-navy/60"}`}>
        {label}
      </div>
      {delta && (
        <span
          data-testid={testId ? `${testId}-delta` : undefined}
          className={`mt-3 inline-block rounded-full px-3 py-1 text-xs font-bold ${
            String(delta).startsWith("-") ? "bg-pink/10 text-pink" : "bg-green/10 text-green"
          }`}
        >
          {delta}
        </span>
      )}
    </motion.div>
  );
}
